/* ─────────────────────────────────────────────────────────
   Startle integration constants.

   The /startle-resolve endpoint takes the code + device id
   that Startle pass on the iframe URL and either logs the
   user in (returns a token, same shape as /auth/token) or
   tells us which set up step they are stuck on.
   ───────────────────────────────────────────────────────── */

export const STARTLE_RESOLVE_MESSAGES = {
  NO_USER: 'user does not exist',
  NO_DEVICE: 'user exists, no device id',
  SETTING_UP: 'user set up in progress'
}

export const STARTLE_UPGRADE_STATES = {
  // No paid KwizzBit account yet — sign up, then contact support
  NO_ACCOUNT: 'no-account',
  // Paid account exists, the device just needs linking to it
  NO_DEVICE: 'no-device',
  // Device linked — waiting on KwizzBit to attach their company
  SETTING_UP: 'setting-up',
  // Nothing to do — device already connected
  CONNECTED: 'connected'
}

export const STARTLE_MESSAGE_TO_STATE = {
  [STARTLE_RESOLVE_MESSAGES.NO_USER]: STARTLE_UPGRADE_STATES.NO_ACCOUNT,
  [STARTLE_RESOLVE_MESSAGES.NO_DEVICE]: STARTLE_UPGRADE_STATES.NO_DEVICE,
  [STARTLE_RESOLVE_MESSAGES.SETTING_UP]: STARTLE_UPGRADE_STATES.SETTING_UP
}
